import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import methodModel from "../../methods/methods";
import CardAnimation from "../../components/CardAnimation";

const CardDetail = () => {
  const [data, setData] = useState()
  const history = useNavigate()
  const { id } = useParams()

  useEffect(() => {
    if (id) {
      getCardDetail()
    }
  }, [id])

  const getCardDetail = () => {
    loader(true);
    ApiClient.get(`card/detail?id=${id}`).then((res) => {
      if (res.success) {
        setData(res.data)
      }
      loader(false)
    })
  }

  // CSS for left side card
  const textElementStyle = {
    position: 'absolute',
    top: `${data?.textPosition?.top}%`,
    right: `${data?.textPosition?.right}%`,
    fontSize: `${data?.textSize}px`,
    color: data?.textColor,
    height: 'auto',
    cursor: 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const imageElementStyle = {
    position: 'absolute',
    top: `${data?.imagePosition?.top}%`,
    right: `${data?.imagePosition?.right}%`,
    width: `${data?.imageSize}%`,
    cursor: 'move',
  };
  const text2ElementStyle = {
    position: 'absolute',
    top: `${data?.text2Position?.top}%`,
    right: `${data?.text2Position?.right}%`,
    fontSize: `${data?.text2Size}px`,
    color: data?.text2Color,
    height: 'auto',
    cursor: 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const stickerStampElementStyle = {
    position: 'absolute',
    top: `${data?.stickerStampPosition?.top}%`,
    right: `${data?.stickerStampPosition?.right}%`,
    width: `${data?.stickerStampSize}%`,
    cursor: 'move',
  };

  // CSS for right side card
  const secondImageTextElementStyle = {
    position: 'absolute',
    top: `${data?.secondImageTextPosition?.top}%`,
    right: `${data?.secondImageTextPosition?.right}%`,
    fontSize: `${data?.secondImageTextSize}px`,
    color: data?.secondImageTextColor,
    height: 'auto',
    cursor: 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const secondImageElementStyle = {
    position: 'absolute',
    top: `${data?.secondImagePosition?.top}%`,
    right: `${data?.secondImagePosition?.right}%`,
    width: `${data?.secondImageSize}%`,
    cursor: 'move',
  };
  const secondImageText2ElementStyle = {
    position: 'absolute',
    top: `${data?.secondImageText2Position?.top}%`,
    right: `${data?.secondImageText2Position?.right}%`,
    fontSize: `${data?.secondImageText2Size}px`,
    color: data?.secondImageText2Color,
    height: 'auto',
    cursor: 'move',
    userSelect: 'none',
    textAlign: 'center',
    lineHeight: 'normal',
  };
  const secondImageStickerStampElementStyle = {
    position: 'absolute',
    top: `${data?.secondImageStickerStampPosition?.top}%`,
    right: `${data?.secondImageStickerStampPosition?.right}%`,
    width: `${data?.secondImageStickerStampSize}%`,
    cursor: 'move',
  };

  return (
    <>
      <Layout>
        <div className="wrapper_section">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span onClick={() => history(-1)} className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">Card Details</h3>
            </div>
          </div>
          <div className="space-y-6">
            {/* Basic Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Name */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center">
                  <span className="md:w-40 font-medium text-gray-500">Name:</span>
                  <span className="text-gray-800 capitalize">{data?.name || "--"}</span>
                </div>
              </div>

              {/* Category */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center">
                  <span className="md:w-40 font-medium text-gray-500">Category:</span>
                  <span className="text-gray-800 capitalize">{data?.categoryId?.name || "--"}</span>
                </div>
              </div>

              {/* Sub Category */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center">
                  <span className="md:w-40 font-medium text-gray-500">Sub Category:</span>
                  <span className="text-gray-800 capitalize">{data?.subCategoryId?.name || "--"}</span>
                </div>
              </div>

              {/* Front Image */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center">
                  <span className="md:w-40 font-medium text-gray-500">Front Image:</span>
                  <span className="text-gray-800 capitalize">{data?.envelopeId?.name || "--"}</span>
                </div>
              </div>
              {/* <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-start">
                  <span className="md:w-40 font-medium text-gray-500">Envelope:</span>
                  <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
                    {data?.envelope_details?.length !== 0 ? (
                      data?.envelope_details?.map((item, index) => (
                        <span key={index} className="bg-yellow-100 capitalize text-yellow-800 px-2 py-1 border border-yellow-300 rounded text-sm">
                          {item?.name}
                        </span>
                      ))
                    ) : (
                      <span className="text-gray-800">--</span>
                    )}
                  </div>
                </div>
              </div> */}

              {/* Audios */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-start">
                  <span className="md:w-40 font-medium text-gray-500">Audios:</span>
                  <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
                    {data?.audioIds?.length !== 0 ? (
                      data?.audio_details?.map((item, index) => (
                        <span key={index} className="bg-yellow-100 capitalize text-yellow-800 px-2 py-1 border border-yellow-300 rounded text-sm">
                          {item?.title}
                        </span>
                      ))
                    ) : (
                      <span className="text-gray-800">No Audio</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Price */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-center">
                  <span className="md:w-40 font-medium text-gray-500">Price:</span>
                  <span className="text-gray-800">{data?.price ? `${data?.price} USD` : "--"}</span>
                </div>
              </div>

              {/* Tags */}
              <div className="bg-white border rounded-xl p-4 shadow-sm">
                <div className="flex flex-col md:flex-row md:items-start">
                  <span className="md:w-40 font-medium text-gray-500">Tags:</span>
                  <div className="flex flex-wrap gap-2 mt-2 md:mt-0">
                    {data?.tags?.map((item, index) => (
                      item && <span key={index} className="bg-blue-100 capitalize text-blue-700 px-2 py-1 rounded text-sm">{item}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Card Section */}
            <div className="bg-white border rounded-xl p-4 shadow-md">
              <span className="block text-md font-medium text-gray-500 mb-4">Card Preview:</span>
              <div className="grid grid-cols-1 gap-4">
                <div className="flex items-center justify-center">
                  <CardAnimation detail={data} />
                </div>

                {/* Commented: Optional second card view */}
                {/* 
      <div className="relative">
        <img src={methodModel.noImg(data?.image)} className="" id="image" />
        <div style={textElementStyle} className="p-1 cursor-grab" dangerouslySetInnerHTML={{ __html: data?.text }}></div>
        {data?.stickerImage && (
          <img style={imageElementStyle} src={methodModel.userImg(data?.stickerImage)} className="p-1" />
        )}
        {data?.text2 && (
          <div style={text2ElementStyle} className="p-1" dangerouslySetInnerHTML={{ __html: data?.text2 }}></div>
        )}
        {data?.stickerStamp && (
          <img style={stickerStampElementStyle} src={methodModel.noImg(data?.stickerStamp)} className="p-1" />
        )}
      </div>
      */}
              </div>
            </div>
          </div>

        </div>
      </Layout>
    </>
  );
};

export default CardDetail;
